// extracted by mini-css-extract-plugin
export default {"container":"loader-module__container___vbyVd","loader":"loader-module__loader___xGXQA","playSmall":"loader-module__playSmall___EZLZI","play":"loader-module__play___crjJH"};